import { IsTest, getLang, isSea, isEu } from '@/utils/tools';
import { game_id } from '@/utils/const';
import { request } from '..';
// const
// const WANDPREFIX = IsTest? '': ''
// api/flow  yace/flow
export const APIS = {
  sea: {
    init: 'api/flow/Wand-20240913025306-Fe3ccb6d7932a', // 初始化
    genShareCode: 'api/flow/Wand-20240913025306-Fd84913c019a3', // 生成邀请码
    bindShareCode: 'api/flow/Wand-20240913025306-F7c9a0b247e23', // 绑定邀请码
    myTaskList: 'api/flow/Wand-20240919144232-eba825e0665e9', // 邀请人任务列表
    inviteTaskList: 'api/flow/Wand-20240919144358-ccdf29698bfef', // 被邀请人列表
    lottery: 'api/flow/Wand-20240913025306-F72eed2bcd0cd', // 抽奖
    lotteryPresents: 'api/flow/Wand-20240913025306-F5fb6a4ef2422', // 抽奖奖励列表
    sendAddress: 'api/flow/Wand-20240919173844-0782fe2232484', // 填写邮箱
    getAddress: 'api/flow/Wand-20240919173921-dbf2648aeb5b7', // 获取已经填写的邮箱
    sendCashEmail: 'api/flow/Wand-20241008174213-07bd60d2e96db', // 填写现金邮箱
    getCashEmail: 'api/flow/Wand-20241008200711-d0ae654ed042b', // 获取现金邮箱
    bindRole: 'api/flow/Wand-20240913025306-F5519d4f1a004', // 绑定角色
    getRole: 'api/flow/Wand-20240913025306-Fef09efe53bc9', // 查询角色列表
    addLotteryNum: 'api/flow/Wand-20241008160509-a6f1fc54a3a2d', // 增加抽奖机会
  },
  eu_am: {
    init: 'api/flow/Wand-20240912152448-00b27d5a25a7f',
    genShareCode: 'api/flow/Wand-20240912152737-e2ecf946a5842',
    bindShareCode: 'api/flow/Wand-20240912152952-857ce02422a84',
    myTaskList: 'api/flow/Wand-20240919144523-52e17ec1e279f',
    inviteTaskList: 'api/flow/Wand-20240919144511-3c03f98134770',
    lottery: 'api/flow/Wand-20240912153901-bebf1b252380a',
    lotteryPresents: 'api/flow/Wand-20240912172005-677cbd74ae898',
    sendAddress: 'api/flow/Wand-20240919174503-413ba78a53441',
    getAddress: 'api/flow/Wand-20240919174528-8b849b6466b80',
    bindRole: 'api/flow/Wand-20240912152355-9ac7e127fb6a5',
    getRole: 'api/flow/Wand-20240912152256-736e7a12a4858',
    addLotteryNum: 'api/flow/Wand-20241008160656-41dea3d887011',
  },
};
const AREA = isSea || isEu ? (isSea ? 'sea' : 'eu_am') : 'sea';

// TODO 请求域名确定
const testOrigin = 'https://test-sg-act.playerinfinite.com/';
const prodOrigin = 'https://sg-act.playerinfinite.com/';
const origin = IsTest ? testOrigin : prodOrigin;
interface commomRes {
  code: number;
  msg: string;
  data?: any;
}
/** 角色item 信息 */
export interface RoleInfo {
  area_id: string;
  game_id: number;
  game_name: string;
  plat_id: string;
  role_name: string;
  zone_id: string;
  role_id: string;
}

const lang_type = getLang();
/** 查询角色列表 请求 */
export interface GetRoleInfoReq {
  area_id: string;
  zone_id: string;
}
/** 查询角色列表 返回 */
export interface GetRoleInfoRes extends commomRes {
  data: {
    role_list: RoleInfo[];
  };
}

// @see https://yapi.intlgame.com/project/1344/interface/api/83796
/** 查询角色列表  */
export const getRoleInfo = async (params: GetRoleInfoReq) => {
  // const otherurl = "api/flow/Wand-20240520072219-Fd615bb497d8b";
  const otherurl = APIS[AREA].getRole;
  return request
    .post<GetRoleInfoRes>(`${origin}${otherurl}`, {
      checkLogin: true,
      needLogin: true,
      lang_type,
      ...params,
    })
    .then((res) => res.data);
};

type SaveRoleInfoRes = commomRes;
// @see https://yapi.intlgame.com/project/1344/interface/api/83816
/** 保存角色  */
export const saveRoleInfo = async (params: Partial<RoleInfo>) => {
  // const otherurl = "api/flow/Wand-20240520072255-F1f5e10f683b3";
  const otherurl = APIS[AREA].bindRole;
  return request
    .post<SaveRoleInfoRes>(`${origin}${otherurl}`, params)
    .then((res) => res.data);
};

interface GetLoginedInitInfoRes extends commomRes {
  data: {
    get_saved_role_info: RoleInfo; // 角色信息
    guess_list: number[]; //当天竞猜
    vote_list: number[]; // 当天主投票
  };
}
// 初始化
export const getLoginedInitInfo = async () => {
  // const otherurl = "api/flow/Wand-20240528125155-Fd1732edc6b8f";
  const otherurl = APIS[AREA].init;
  return request
    .post<GetLoginedInitInfoRes>(`${origin}${otherurl}`, {
      checkLogin: true,
      needLogin: false,
      lang_type,
    })
    .then((res) => res.data);
};

export const submitAddress = async (params: RecordArress) => {
  const otherurl = 'api/flow/Wand-20240520073756-F0608666e25d7';
  return request
    .post<commomRes>(`${origin}${otherurl}`, {
      checkLogin: true,
      needLogin: true,
      lang_type,
      ...params,
    })
    .then((res) => res.data);
};
/** 初始化 */
export interface InitRes extends commomRes {
  data: {
    lottery_num: number;
    finish_all_task_num: {
      num: string;
    };
    invited_people_num: {
      num: string;
    };
    get_saved_role_info: {
      role_name: string;
      role_id: string;
      area_id: string;
      zone_id: string;
    };
    has_saved_role_info: boolean;
    is_newinstall_or_active: {
      isActive: boolean; // 回流
      isNewInstall: boolean; //新进
    };
    is_invited: boolean;
  };
}
export const wandInit = async () => {
  const otherurl = APIS[AREA].init;
  console.log('wandInit', otherurl);
  return request
    .post<InitRes>(`${origin}${otherurl}`, {
      checkLogin: true,
      needLogin: true,
      lang_type,
    })
    .then((res) => res.data);
};
/** 生成邀请码 */
export interface GenShareCodeRes extends commomRes {
  data: {
    share_code: string;
  };
}

export const getMyShareCode = async () => {
  // const otherurl = "api/flow/Wand-20240520073827-Fa178ef7cecc6";
  const otherurl = APIS[AREA].genShareCode;
  console.log('getMyShareCode', otherurl);
  return request
    .post<GenShareCodeRes>(`${origin}${otherurl}`, {
      checkLogin: true,
      needLogin: true,
      lang_type,
    })
    .then((res) => res.data);
};
/** 绑定邀请码 */
export interface TypeBindShareCodeReq {
  share_code: string;
}
export interface BindShareCodeRes extends commomRes {
  data: {
    common_object_bool_value?: string | null;
    common_show_boolean?: boolean;
    is_newinstall_or_active: {
      isActive: boolean; // 是否是回流
      isNewInstall: boolean; // 是否是新进 如果和回流都为false代表没有资格
    };
    role_info: RoleInfo;
  };
}
/** 提交绑定邀请码 */
export const bindMyShareCode = async (params: TypeBindShareCodeReq) => {
  // const otherurl = "api/flow/Wand-20240520073827-Fa178ef7cecc6";
  const otherurl = APIS[AREA].bindShareCode;
  console.log('BindShareCodeRes', otherurl);
  return request
    .post<BindShareCodeRes>(`${origin}${otherurl}`, {
      checkLogin: true,
      needLogin: true,
      lang_type,
      ...params,
    })
    .then((res) => res.data);
};
/** 邀请人任务列表 */
export interface MyTaskListRes extends commomRes {
  data: {
    invite_people_list: {
      Task1: number;
      Task2: number;
      Task3: number;
    };
  };
}

export interface TypeInviteTaskListItem {
  task_1: number;
  task_2: number;
  task_3: number;
  role_name: string; // 邀请人
  invitation_role_name: string;
}
/** 被邀请人列表 */
export interface InviteTaskListRes extends commomRes {
  data: {
    invite_people_list: {
      people_list: TypeInviteTaskListItem[];
      total: number;
    };
  };
}
export const getMyInviteList = async () => {
  // const otherurl = "api/flow/Wand-20240520073827-Fa178ef7cecc6";
  const otherurl = APIS[AREA].inviteTaskList;
  console.log('getMyInviteList', otherurl);
  return request
    .post<InviteTaskListRes>(`${origin}${otherurl}`, {
      checkLogin: true,
      needLogin: true,
      lang_type,
    })
    .then((res) => res.data);
};

export interface InviteListRes extends commomRes {
  data: {
    invite_people_list: {
      task_1: number;
      task_2: number;
      task_3: number;
    };
  };
}
export const getInviteList = async () => {
  // const otherurl = "api/flow/Wand-20240520073827-Fa178ef7cecc6";
  const otherurl = APIS[AREA].myTaskList;
  console.log('getInviteList', otherurl);
  return request
    .post<InviteListRes>(`${origin}${otherurl}`, {
      checkLogin: true,
      needLogin: true,
      lang_type,
    })
    .then((res) => res.data);
};

// invite_people_list

/** 奖品item */
export interface Present {
  detail?: {
    cark?: string;
    cdkey?: string;
    password?: string;
    role_info?: null;
    serial_no?: string;
  };
  level: string;
  present_cid: string;
  present_id: string;
  present_img: string;
  present_name: string;
  present_name_language: string | null;
  present_type: string;
  send_status: number;
  send_timestamp: string;
  sent_remark: string;
  unsend_present_key: string;
}
/** 抽奖奖励列表 */
export interface MyPresentList {
  present_has_list?: Present[];
}

/** 抽奖 */
export interface LotteryRes extends commomRes {
  data: {
    present?: {
      present_id?: string;
      send_type?: number;
      present_list?: Present[];
    };
  };
}
export const wandLottery = async () => {
  const otherurl = APIS[AREA].lottery;
  console.log('lottery', otherurl);
  return request
    .post<LotteryRes>(`${origin}${otherurl}`, {
      checkLogin: true,
      needLogin: true,
      lang_type,
    })
    .then((res) => res.data);
};

/** 抽奖奖励列表 */
export interface TypeLotteryPresent {
  present_cid: string;
  present_id: string;
  present_img: string;
  present_name: string;
  present_name_language: string;
  present_type: string;
  send_status: number;
  send_timestamp: string;
  sent_remark: string;
  unsend_present_key: string;
  detail: {
    cark?: string;
    cdkey?: string;
    password?: string;
    role_info?: null;
    serial_no?: string;
  };
  level: string;
}
export interface TypeLotteryPresentsRes extends commomRes {
  data: {
    present_has_list?: {
      present_list: TypeLotteryPresent[];
      total_num: number;
    };
  };
}
interface TypeLotteryPresentReq {
  page_size: number;
  page_num: number;
}
/** 抽奖奖励列表 */
export const wandLotteryPresents = async (params: TypeLotteryPresentReq) => {
  const otherurl = APIS[AREA].lotteryPresents;
  console.log('lotteryPresents', otherurl);
  return request
    .post<TypeLotteryPresentsRes>(`${origin}${otherurl}`, {
      checkLogin: true,
      needLogin: true,
      lang_type,
      ...params,
    })
    .then((res) => res.data);
};

/** 填写邮箱 */
export interface RecordArress {
  name: string;
  address: string;
  email: string;
  zip_code?: string;
  phone_number?: string;
  country?: string;
}
interface GetAddressRes extends commomRes {
  data: {
    address_info: RecordArress;
  };
}

export interface TypeGetAddressReq {
  name?: string;
}
/** 获取抽奖的地址 */
export const getAddress = async (params: TypeGetAddressReq) => {
  // const otherurl = "api/flow/Wand-20240520073827-Fa178ef7cecc6";
  const otherurl = APIS[AREA].getAddress;
  console.log('getAddress', otherurl);
  return request
    .post<GetAddressRes>(`${origin}${otherurl}`, {
      checkLogin: true,
      needLogin: true,
      lang_type,
      ...params,
    })
    .then((res) => res.data);
};
export interface TypeSendAddressReq {
  email?: string;
  country?: string;
  phone_number?: string;
  name?: string;
  zip_code?: string;
  address?: string;
}
/** 提交抽奖的地址 */
export const sendAddress = async (params: TypeSendAddressReq) => {
  // const otherurl = "api/flow/Wand-20240520073827-Fa178ef7cecc6";
  const otherurl = APIS[AREA].sendAddress;
  console.log('sendAddress', otherurl);
  return request
    .post<commomRes>(`${origin}${otherurl}`, {
      checkLogin: true,
      needLogin: true,
      lang_type,
      ...params,
    })
    .then((res) => res.data);
};
/** 亚服 填写现金邮箱 */
export const sendCashEmail = async (params: TypeSendAddressReq) => {
  // const otherurl = "api/flow/Wand-20240520073827-Fa178ef7cecc6";
  if (AREA !== 'sea') return { code: -1, msg: 'error', data: null };
  const otherurl = APIS[AREA].sendCashEmail;
  console.log('sendCashEmail', otherurl);
  return request
    .post<commomRes>(`${origin}${otherurl}`, {
      checkLogin: true,
      needLogin: true,
      lang_type,
      ...params,
    })
    .then((res) => res.data);
};
/** 亚服 获取现金邮箱 */
export const getCashEmail = async (params: TypeGetAddressReq) => {
  // const otherurl = "api/flow/Wand-20240520073827-Fa178ef7cecc6";
  if (AREA !== 'sea') return { code: -1, msg: 'error', data: null };
  const otherurl = APIS[AREA].getCashEmail;
  console.log('getCashEmail', otherurl);
  return request
    .post<GetAddressRes>(`${origin}${otherurl}`, {
      checkLogin: true,
      needLogin: true,
      lang_type,
      ...params,
    })
    .then((res) => res.data);
};
/** 增加抽奖次数 */
export const addLotteryNum = async () => {
  const otherurl = APIS[AREA].addLotteryNum;
  return request
    .post<commomRes>(`${origin}${otherurl}`, {
      checkLogin: true,
      needLogin: true,
      lang_type,
    })
    .then((res) => res.data);
};

function getSourceFromUrl(search = window.location.search) {
  const params = new URLSearchParams(search);
  const source = ['media', 'network', 'campaign', 'adgroup', 'ad']
    .map((key) => {
      return `${key}=${encodeURIComponent(params.get(key) || '')}`;
    })
    .join('&');
  const clickId =
    params.get('gclid') ||
    params.get('fbclid') ||
    params.get('twclid') ||
    params.get('msclkid') ||
    params.get('yclid') ||
    params.get('_zucks_suid') ||
    params.get('transaction_id') ||
    '';

  return `${source}&clickid=${clickId}`;
}
const baseRequestUrl = 'https://www.jupiterlauncher.com';

async function wandFetch(url: string, data: any) {
  const rawResponse = await fetch(`${baseRequestUrl}${url}`, {
    method: 'post',
    body: JSON.stringify(data),
    headers: {
      'Content-Type': 'application/json',
    },
  });
  const response = await rawResponse.json();

  return response;
}

export const getShort = async () => {
  const source = getSourceFromUrl();
  const now = Math.ceil(Date.now() / 1000);
  const seq = '';
  const response = await wandFetch(
    `/api/v1/fleet.platform.game.TinyLinkProxy/Long2Short?channel_id=3&game_id=${game_id}&sdk_version=2.0&seq=${seq}&source=1&ts=${now}`,
    { code: `${source}` }
  );
  return response;
};
